import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=050b89d2&scoped=true&"
import script from "./progress.vue?vue&type=script&lang=js&"
export * from "./progress.vue?vue&type=script&lang=js&"
import style0 from "./progress.vue?vue&type=style&index=0&id=050b89d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b89d2",
  null
  
)

export default component.exports